// Kept apart from post-actions/handlers/resize.js: that handler imports the layout editor
// (copy-and-resize…), and modules that only need the keys (store, modals) must not pull it in.
export const POST_ACTION_RESIZE_KEY = 'resize';
export const POST_ACTION_RESIZE_DATA_KEY = 'post-action:resize';
